import React from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import config from "./config";

interface ProtectedRouteProps {
  component?: React.ComponentType<any>;
  isAuthenticated?: boolean;
  [key: string]: any;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = () => {
  const location = useLocation();
  const token = Cookies.get(config.tokenCookieName);
  const isAuthenticated = !!token;

  // `replace` keeps the guarded URL out of history so Back does not bounce the
  // user through the guard again; `state.from` lets signin return them here.
  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to="/signin" replace state={{ from: location }} />
  );
};

export default ProtectedRoute;
